



































































import { Component, Vue, Ref } from 'vue-property-decorator';
import ModuleList from '@/views/module/components/moduleList.vue';
import ModuleDetail from '@/views/module/components/moduleDetail.vue';
import ModuleTemplateDetail from '@/views/module/components/moduleTemplateDetail.vue';
import { compareObj, searchParamsConvertArray, ISearchTag } from '@/utils/other';
import SearchModal from '@/components/searchModal/searchModal.vue';
import TemplateListModal from './components/templateListModal.vue';
import { moduleListInstance } from '@/model/ModuleListClass';
import { templateListInstance } from '@/model/ModuleTemplateListClass';
import { TagsViewModule } from '@/store/modules/tagsView';

type ISearchModules = IModule.IRequest.ISearchModules;
type IModuleStatusTxt = IModule.IModuleStatus;
type IModuleInfo = IModule.IResponse.IModuleInfo;
type IModuleTemplateInfo = IModule.IResponse.IModuleTemplateInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;
type IModuleTemplateParams = IModule.IRequest.IModuleTemplateParams;


@Component({
  name: 'Module',
  components: {
    ModuleList,
    ModuleDetail,
    SearchModal,
    ModuleTemplateDetail,
    TemplateListModal,
  },
})
export default class Module extends Vue {
  @Ref() private readonly searchModalRef!: SearchModal;
  @Ref() private readonly templateListModalRef!: TemplateListModal;
  private isInitData = false;
  private moduleForSearch: IModule.IRequest.ISearchModules = {};
  private searchTags: ISearchTag[] = [];
  private searchStatusOption: Array<IModuleStatusTxt | 'All'> = ['All', 'Processing', 'Completed', 'Closed', 'Cancel'];
  private searchByKeyword = '';
  private searchByStatus: IModuleStatusTxt | 'All' = 'Processing';
  private moduleListInstance = moduleListInstance;
  private templateListInstance = templateListInstance;
  private listSpinning = false;
  private detailSpinning = false;
  private addLoading = false;

  get listData() {
    return this.moduleListInstance.list.data;
  }
  get templateListData() {
    return this.templateListInstance.list.data;
  }
  get activeId() {
    return this.currentModule?.id || this.currentTemplate?.id || '';
  }
  get isMore() {
    return this.moduleListInstance.isMore;
  }
  get currentModule() {
    return this.moduleListInstance.list.current;
  }
  get currentTemplate() {
    return this.templateListInstance.list.current;
  }
  private created() {
    this.initData();
  }
  private activated() {
    this.initData();
  }
  private initData() {
    if (Object.keys(this.$route.params).length && !compareObj(this.$route.params, this.moduleForSearch)) {
      this.moduleForSearch = {...this.$route.params};
      this.searchTags = searchParamsConvertArray(this.moduleForSearch);
      this.refreshModule();
      this.isInitData = true;
      TagsViewModule.ChangeView({...this.$route, params: {}});
      return;
    }
    if (!this.isInitData) {
      this.initModules({
        status: 'Processing',
      });
      this.isInitData = true;
    }
    this.initModuleTemplate();
  }
  private destroyed() {
    moduleListInstance.list.clearData();
  }
  private refreshModule() {
    this.searchByStatus = 'All';
    this.searchByKeyword = '';
    this.initModules(this.moduleForSearch);
    this.initModuleTemplate();
  }
  private handleSearch() {
    this.removeModuleForSearch();
    const params: ISearchModules = {};
    if (this.searchByStatus !== 'All') {
      params.status = this.searchByStatus;
    }
    if (this.searchByKeyword !== '') {
      params.title = this.searchByKeyword;
    }
    this.initModules(params);
  }
  private initModules(params?: ISearchModules) {
    this.listSpinning = true;
    this.moduleListInstance.requestData(params).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.listSpinning = false;
    });
  }
  private initModuleTemplate() {
    this.templateListInstance.requestLoadTemplates().catch((err) => {
      this.$message.warning(err);
    });
  }
  private removeModuleForSearch() {
    this.moduleForSearch = {};
    this.searchTags.length = 0;
  }
  private handleCreate() {
    this.$router.push({
      name: 'CreateModule',
    });
  }
  private handleCreateTemplate() {
    this.$router.push({
      name: 'CreateTemplate',
    });
  }
  private removeSearchParams(key: keyof ISearchModules) {
    delete this.moduleForSearch[key];
    this.searchTags = searchParamsConvertArray(this.moduleForSearch);
    this.refreshModule();
  }
  private showSearchModal() {
    this.searchModalRef.showModal();
  }
  private handleModalSearch(params: ISearchModules) {
    this.moduleForSearch = params;
    this.searchTags = searchParamsConvertArray(this.moduleForSearch);
    this.refreshModule();
  }
  private getMoreData() {
    this.addLoading = true;
    this.moduleListInstance
      .requestMoreData()
      .catch((err) => 'requestMoreModules err' + err)
      .finally(() => {
        this.addLoading = false;
      });
  }
  private handleItemClick(module: IModuleInfo | IModuleTemplateInfo) {
    if ('quotationId' in module) {
      this.moduleListInstance.list.changeCurrent(module);
      this.templateListInstance.list.changeCurrent(undefined);
    } else {
      this.templateListInstance.list.changeCurrent(module);
      this.moduleListInstance.list.changeCurrent(undefined);
    }
  }
  private refreshDetail(module: IModuleInfo) {
    this.detailSpinning = true;
    this.moduleListInstance
      .requestDetail({
        id: module.id,
      })
      .catch((err) => {
        if (err !== 'CANCEL') {
          this.$message.warning(err);
        }
      })
      .finally(() => {
        this.detailSpinning = false;
      });
  }
  private editModule(module: IModuleInfo) {
    this.moduleListInstance.changeEditItem(module);
    this.$router.push({
      name: 'UpdateModule',
    });
  }
  private deleteModule(moduleId: string) {
    this.moduleListInstance.requestDeleteById(moduleId).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private changeStatus(params: {
    module: IModuleInfo;
    status: IModule.IModuleStatus;
  }) {
    this.moduleListInstance.requestUpdateStatus(
      params.module,
      params.status,
    );
  }
  private changeLabel(params: {
    module: IModuleInfo;
    labels: ILabelInfo[];
  }) {
    this.moduleListInstance.updateLabel(params.module, params.labels);
  }
  private changeComment(params: {
    type: 'ADD' | 'CHANGE';
    module: IModuleInfo;
    comment: ICreateOrUpdateComment;
  }) {
    const { type, module, comment } = params;
    this.moduleListInstance.updateComment(type, module, comment);
  }
  private saveTemplate(templateData: IModuleTemplateParams) {
    this.templateListInstance.saveTemplate(templateData);
  }
  private cancelTemplate(params: {
    module: IModuleTemplateInfo;
  }) {
    this.templateListInstance.cancelTemplate(params.module.id).catch((errMsg) => {
      this.$message.warning(errMsg);
    });
  }
  private deleteTemplate(templateId: string) {
    this.templateListInstance.deleteTemplate(templateId).catch((errMsg) => {
      this.$message.warning(errMsg);
    });
  }
  private changeTemplateComment(params: {
    type: 'ADD' | 'CHANGE';
    template: IModuleTemplateInfo;
    comment: ICreateOrUpdateComment;
  }) {
    const { type, template, comment } = params;
    this.templateListInstance.updateComment(type, template, comment);
  }
  private editTemplate(template: IModuleTemplateInfo) {
    this.templateListInstance.changeEditItem(template);
    this.$router.push({
      name: 'UpdateTemplate',
    });
  }
  private handleSelectTemplate() {
    this.templateListModalRef.showModal();
  }
}
